<td class="type-label">{{diaryTypeLabel}}</td>
<td class="name-label">{{name}}</td>
<td class="value-label">{{valueFormatted}}</td>
<td>
  <div class="dropdown"
       dropdown
       #dropdown="bs-dropdown"
       (click)="$event.stopPropagation()"
       container="body">
    <button #bAct
            (click)="$event.stopPropagation()"
            [class.disabled]="actionLoading"
            class="btn btn-outline-primary btn-outline icon-only circle more-action-button"
            dropdownToggle
            id="more-button"
            type="button">
      <ng-container *ngIf="actionLoading else moreActionButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #moreActionButton>
        <i i-bs name="three-dots" width="15" height="15"></i>
      </ng-template>
    </button>

    <div class="dropdown-backdrop fade" (click)="dropdown.hide()"></div>
    <ul *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        [class.dropstart]="!offsetDropdown(bAct, 100)"
        [class.dropend]="offsetDropdown(bAct, 100)"
        role="menu">
      <li role="menuitem"><span class="dropdown-item" id="action-delete"
          (click)="dropdown.hide(); onDelete.emit()">Supprimer</span></li>
      <li class="divider dropdown-divider"></li>
      <li role="menuitem"><span id="cancel-link" class="dropdown-item action" (click)="dropdown.hide()">Annuler</span>
      </li>
    </ul>
  </div>
</td>
